// Bus de publication des guides actifs (pattern Observer).
//
// Volontairement HORS du store Zustand : ces données sont éphémères (durée d'un
// drag), locales à un navigateur, jamais persistées, jamais diffusées en collab
// — les faire transiter par le store polluerait l'état métier, l'undo et le
// diff, et déclencherait un re-render de l'arbre à chaque mousemove.
//
// L'abonné unique (SnapGuidesOverlay) écrit directement dans le DOM sous
// requestAnimationFrame : aucun re-render React pendant le drag.

const EMPTY_GUIDES = [];

let state = { active: false, parentId: null, guides: EMPTY_GUIDES };
const listeners = new Set();

export const getSnapState = () => state;

export const subscribeSnap = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const publishSnap = (next) => {
  state = next;
  listeners.forEach((listener) => listener(state));
};

export const clearSnap = () => {
  if (!state.active && state.guides === EMPTY_GUIDES) return;
  publishSnap({ active: false, parentId: null, guides: EMPTY_GUIDES });
};
